import {ConstraintsBuilder} from './constraints-builder';

const Factory = {
    getBuilder(sportConfig) {
        return ConstraintsBuilder;
    },
};

export {Factory};
